import React from 'react';
import { Investment } from '@/types/investment';

interface EssentialsProps {
  investment: Investment;
}

const Essentials: React.FC<EssentialsProps> = ({ investment }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold text-foreground">Essentials</h2>
      <ul className="mt-6 space-y-0 list-none p-0 divide-y divide-border">
        {investment.essentials.map((item, index) => (
          <li key={index} className="flex justify-between items-center py-4">
            <span className="text-sm text-muted-foreground">{item.label}</span>
            <span className="text-sm text-foreground font-medium text-right">{item.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Essentials;
